export default {
    "search": {
        "emptySearchNotification": "Bitte geben Sie einige Suchbegriffe ein, um eine Suche durchzuführen",
        "alreadyFiltered": "bereits ausgewählt"
    },

    "breadcrumbs": {
        "emptySearch": "<Suche ohne Suchbegriff>",
        "itemRemove": "Entfernen"
    },

    "didYouMean": {
        "dymonlyBeforeCorrected": "Meinten Sie: ",
        "dymonlyAfterCorrected": "?",
        "correctBeforeCorrected": "Zeige Ergebnisse für [",
        "correctBeforeOriginal": "]. Zeige stattdessen Ergebnisse für [",
        "correctAfterOriginal": "]",
        "smartBeforeOriginal": "Zeige Ergebnisse für [",
        "smartBeforeCorrected": "] und [",
        "smartAfterCorrected": "]"
    },

    "pageSizeSelector": {
        "pageSizeChoice": "{size, number} pro Seite",
        "defaultPageSize": "Standard ({size, number})",
        "defaultPageSizeChoice": "{size, number} pro Seite (standard)"
    },

    "pager": {
        "pageNumberTitle": "Seite {page, number}",
        "firstPage": "Erste Seite",
        "nextPage": "Nächste Seite",
        "previousPage": "Vorherige Seite",
        "lastPage": "Letzte Seite"
    },

    "sortSelector": {
        "sortByTitle": "Sortieren nach: {text}",
        "sortOther": "<Andere>"
    },

    "sort": {
        "relevance": "Relevanz",
        "date": "Datum",
        "filename": "Dateiname",
        "title": "Titel"
    },

    "queryIntent": {
        "externalServiceTimeoutError": "Diese Ergebnisseite ist aufgrund eines internen Zeitlimits unvollständig. Bitte versuchen Sie es später noch einmal."
    },

    "scopes": {
        "allScopes": "Alle Quellen"
    }
};
